import request from '@/utils/request'
// import qs from 'qs'

// 留言列表
export const pageList = (getData) => {
  return request({
    url: '/web/leaving-amessage/pageList',
    method: 'get',
    headers: {
      'content-type': 'application/json'
    },
    params: getData
  })
}
// 留言单个详情
export const getId = (getData) => {
  return request({
    url: '/web/leaving-amessage/getId',
    method: 'get',
    headers: {
      'content-type': 'application/json'
    },
    params: getData
  })
}
// 删除
export const deleteMessage = (getData) => {
  return request({
    url: '/web/leaving-amessage/deleteById',
    method: 'get',
    headers: {
      'content-type': 'application/json'
    },
    params: getData
  })
}
// 修改
export const updateMessage = (postData) => {
  return request({
    url: '/web/leaving-amessage/update',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}

// 新增
export const addMessage = (postData) => {
  return request({
    url: '/web/leaving-amessage/save',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}
